import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getFeaturedCities } from 'ha/modules/FeaturedCities/selectors';
import { FeaturedCities } from '../components/FeaturedCities/FeaturedCities';

const enhance = compose(
  connect(
    createStructuredSelector({
      featuredCities: getFeaturedCities,
    }),
  ),
);

const FeaturedCitiesContainer = enhance(FeaturedCities);
export { FeaturedCitiesContainer };
